import { useEffect } from "react";

/**
 * Tiny SEO-head helper. Updates document.title, meta description, canonical URL,
 * and OpenGraph tags. Cleans up on unmount so pages don't leak their metadata.
 */
export function useSeo({ title, description, canonical, image }) {
  useEffect(() => {
    const prev = {
      title: document.title,
      description: getMeta("description")?.getAttribute("content") || "",
    };
    if (title) document.title = title;
    if (description) setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    if (image) setMeta("og:image", image, "property");
    setMeta("twitter:card", "summary_large_image");
    if (canonical) setLink("canonical", canonical);
    return () => {
      document.title = prev.title || "Dry Ice Connect";
      if (prev.description !== undefined) setMeta("description", prev.description);
    };
  }, [title, description, canonical, image]);
}

function getMeta(name, attr = "name") {
  return document.querySelector(`meta[${attr}="${name}"]`);
}

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let tag = getMeta(name, attr);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setLink(rel, href) {
  let tag = document.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}
